import React from "react";
import { Avatar } from "@material-ui/core";
import moment from "moment";
import "./IncidentSidebar.scss";

const extractJiraDocText = (body) => {
  if (body) {
    const usernameMatch = body.match(/^\*username: (.*?)\*/);
    const username = usernameMatch ? usernameMatch[1] : "";
    return { text: body.replace(/^\*.*?\*\s*\n\n/, ""), username: username };
  }
};

const maskComment = (comment) => {
  const email = localStorage.getItem("email");
  let isDruvStarDoman = false;
  if (email && email.includes("@")) {
    const domain = email.split("@")[1];
    isDruvStarDoman = domain === "druvstar.com";
  }
  if (comment && comment.body) {
    let maskedComment = comment.body;
    const regex = /\[([^\|\]]+)\|([^\]]+)\]/g;
    let match;
    while ((match = regex.exec(comment.body)) !== null) {
      let replaceTxt = 'DruvStar Storage'
      if (match && match[1] && match[2]) {
        if (isDruvStarDoman) {
          replaceTxt = `<a href=${match[2]} target="_blank" rel="noopener noreferrer" style="color: #1976d2; text-decoration: underline;">DruvStar Storage</a>`;
        }
      }
      maskedComment = maskedComment.replace(match[2], replaceTxt);
    }
    return maskedComment;
  }
  return comment?.body || "";
};

const IncidentComments = ({ commentResponse }) => {
  if (!commentResponse || !commentResponse.comments || commentResponse.comments.length === 0) {
    return <div className="jira-comments-empty">No comments</div>;
  }
  return (
    <div className="jira-comments-list">
      {[...commentResponse.comments].reverse().map((comment, idx) => {
        const maskedComment = maskComment(comment);
        const commentData = extractJiraDocText(maskedComment);
        const commentAuthor = commentData?.username || comment.author.displayName || "Unknown Author";
        return (
          <div className="jira-comment" key={idx}>
            <div className="jira-comment-header">
              <Avatar className="jira-comment-avatar">
                {commentAuthor.split(' ').map(l => l[0]).join('')}
              </Avatar>
              <span className="jira-comment-author">{commentAuthor}</span>
              <span className="jira-comment-date">
                {moment(comment.created).format("YYYY-MM-DD HH:mm")}
              </span>
            </div>
            <div className="jira-comment-body">
              <span dangerouslySetInnerHTML={{ __html: commentData.text }} />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default IncidentComments;
